import React from "react";
import { Formik, ErrorMessage } from "formik";
import { Button, Modal, ModalBody, Form, FormGroup } from "reactstrap";
import PinInput from "react-pin-input";
import SvgImage from "../../Icons/Icons";
import "./index.css";
import * as Yup from "yup";

import { useDispatch, useSelector } from "react-redux";
import {
  editCardControl,
  getCardControl,
  newEditCardControlAction,
  newGetCardControlAction,
} from "../../../services/Store/Actions/driverslistActions";
import {
  M2PCardControlAction,
  M2pEditCardControlAction,
} from "../../../services/Store/Actions/m2pAction";
import { toastStatus } from "../../../services/Store/Actions/appActions";
import { changeDriverLimit, modifyLimitAction } from "../../../services/Store/Actions/walletAction";
const ReplaceCardModal = (props) => {
  const dispatch = useDispatch();
  const { loader } = useSelector((state) => state?.driverlist);
  const {
    open,
    toggleModal,
    handleClose,
    name,
    handleShowPin,
    setOtpRef,
    setlimitValue,
    otpOpen,
    setConfirm,
    setMsg,
    setKitNo
  } = props;
  let TransactionType = name.split(" ");
  TransactionType = TransactionType[0];
  TransactionType = TransactionType.toLowerCase();
  console.log("kkkkkkkjjjjhis", props);
  return (
    <div>
      <Modal
        isOpen={open}
        onHide={handleClose}
        className="positons settingModalMargin"
        toggle={toggleModal}
        aria-labelledby="myModalLabel2"
      >
        <div
          className="modal-content"
          style={{ width: "530px", overflowY: "scroll", overflowX: "hidden" }}
        >
          <div className="modal-head-part">
            <p className="Add-balance-title">
              Replace Card
            </p>
            <Button
              type="button"
              className="close-btn"
              onClick={toggleModal}
              aria-label="Close"
              disabled={loader ? true : false}
            >
              <SvgImage name="CloseButtonLogo" />
            </Button>
          </div>
          {/* <hr /> */}
          <ModalBody>
            <Formik
              enableReinitialize
              initialValues={{
                newkit: "",
              }}
              onSubmit={(values, actions) => {
                setConfirm(true);
                setMsg("Are you sure you want to replace the card");
                setKitNo(values?.newkit)
              }}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                setFieldValue,
                isSubmitting,
              }) => (
                <Form onSubmit={handleSubmit}>
                  <FormGroup>
                    <div className="sub-title-1">
                      <span class="circle-logo">1</span>
                      <p className="sub-head-3">Enter New Kit Number</p>
                    </div>

                    <label for="html" className="label-body">
                    </label>
                    <input
                      type="text"
                      id="newkit"
                      className={"input-body-1"}
                      name="newkit"
                      value={values.newkit}
                      touched={touched.newkit}
                      errors={errors.newkit}
                      onBlur={handleBlur("newkit")}
                      onChange={handleChange("newkit")}
                      placeholder="Enter Kit Number"
                    ></input>
                    <div className="input-amount"></div>
                    <div style={{ margin: "7px 0 0px 96px", color: "red" }}>
                      {errors.newkit && touched.newkit ? (
                        <div>*{errors.newkit}</div>
                      ) : null}
                    </div>
                    <Button
                      type="submit"
                      className="butt4"
                      disabled={loader ? true : false}
                    >
                      {loader ? "Please Wait" : "Replace Card"}
                    </Button>
                  </FormGroup>
                </Form>
              )}
            </Formik>

            {/* <div className="space-div"></div> */}
          </ModalBody>
        </div>
      </Modal>
    </div>
  );
};
export default ReplaceCardModal;
